<template><div><h1 id="buchungsparametrisierung" tabindex="-1"><a class="header-anchor" href="#buchungsparametrisierung"><span>Buchungsparametrisierung</span></a></h1>
<p>Buchungsparametrisierung — Parametrisierung für Buchungen</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>In dieser Tabelle können verschiedene Parameter für die Buchungen gesetzt werden.</p>
<p>Die Eingabe einer Buchungssperre bewirkt, dass Buchungen nur mit einem Buchungsdatum versehen werden können, das jünger ist als das eingegebene Sperrdatum.</p>
<p>Bei Buchungen auf Zusagen (Zusagenzahlungen) kann ein Ereignis definiert werden, welches immer bei der Buchung vorgeschlagen wird. Das Ereignis kann auch pro organisatorische Einheit definiert werden.</p>
<p>Bei Buchungen von Spenden (Spendenzahlungen) kann ebenfalls ein Ereignis definiert werden, welches immer bei der Buchung vorgeschlagen wird. Das Ereignis kann auch hier pro organisatorische Einheit definiert werden.</p>
<p>Pfad: <code v-pre>Buchhaltung → Tabellen → Buchungsparametrisierung</code></p>
<h2 id="datenfelder-buchungssperre" tabindex="-1"><a class="header-anchor" href="#datenfelder-buchungssperre"><span>Datenfelder (Buchungssperre)</span></a></h2>
<dl>
<dt>Sperre für Buchungen bis Datum</dt>
<dd>Eingabe des Sperrdatums. Buchungen vor diesem Datum sind dann nicht mehr möglich.</dd>
</dl>
<h2 id="datenfelder-ereignisvorschlag-bei-zusagezahlungen" tabindex="-1"><a class="header-anchor" href="#datenfelder-ereignisvorschlag-bei-zusagezahlungen"><span>Datenfelder (Ereignisvorschlag bei Zusagezahlungen)</span></a></h2>
<dl>
<dt>OE</dt>
<dd>Einschränkung nach der organisatorischen Einheit. Der Ereignisvorschlag gilt nur für die definierte OE. Dieses Feld kann aber auch leer gelassen werden, dann gilt es für alle.</dd>
<dt>Ereignis</dt>
<dd>Ereignis welches bei der Buchung vorgeschlagen wird.</dd>
<dt>Beschreibung</dt>
<dd>Beschreibung des Ereignisses.</dd>
</dl>
<h2 id="datenfelder-ereignisvorschlag-bei-spendenzahlungen" tabindex="-1"><a class="header-anchor" href="#datenfelder-ereignisvorschlag-bei-spendenzahlungen"><span>Datenfelder (Ereignisvorschlag bei Spendenzahlungen)</span></a></h2>
<dl>
<dt>OE</dt>
<dd>Einschränkung nach der organisatorischen Einheit. Der Ereignisvorschlag gilt nur für die definierte OE. Dieses Feld kann aber auch leer gelassen werden, dann gilt es für alle.</dd>
<dt>Ereignis</dt>
<dd>Ereignis welches bei der Buchung vorgeschlagen wird.</dd>
<dt>Beschreibung</dt>
<dd>Beschreibung des Ereignisses.</dd>
</dl>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
<p><RouteLink to="/manual/buchhaltung/debitorenverwaltung.html" title="Kapitel 6. Buchhaltung">Buchhaltung</RouteLink>--&gt;</p>
</div></template>


